import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "opModal inputModal p-3 text-center" }
const _hoisted_2 = { class: "logoIcon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "header mt-3"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "body mt-2" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["type", "placeholder"]
const _hoisted_10 = { class: "mt-3 mw-700" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_date = _resolveDirective("date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.$store.state.consts.projectConfig.logoUrl
      }, null, 8, _hoisted_3)
    ]),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "midTitle",
            innerHTML: _ctx.title
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", { innerHTML: _ctx.text }, null, 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", null, _toDisplayString(_ctx.text), 1),
        _withDirectives(_createElementVNode("input", {
          ref: "input",
          class: "form-control",
          type: _ctx.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
          placeholder: _ctx.placeholder
        }, null, 8, _hoisted_9), [
          [_vModelDynamic, _ctx.localValue],
          [_directive_date, _ctx.type == 'date']
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-block btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args))),
            disabled: !_ctx.localValue
          }, [
            _createElementVNode("span", { innerHTML: _ctx.okText }, null, 8, _hoisted_12)
          ], 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-block btn-secondary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ko && _ctx.ko(...args)))
          }, [
            _createElementVNode("span", { innerHTML: _ctx.koText }, null, 8, _hoisted_14)
          ])
        ])
      ])
    ])
  ]))
}